<template lang="pug">
b-modal(
  id="recommended-rent-fee-popup"
  size="lg"
  hide-footer
  hide-header-close
  @hidden="resetModal"
)
  .container
    .factor-chart(ref="factor_price")
    span.no-data(v-if="isEmpty(chartData)") No any data

</template>

<script>
import {api} from '@/api'
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"
import { isEmpty, orderBy } from 'lodash'

export default {
  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    },
    room: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      chartData: [],
      chart: undefined
    }
  },

  computed: {
    apiUrl() {
      return `properties/${this.property.id}/rooms/${this.room.id}/factor_prices`
    },

    orderedChartData() {
      return orderBy(this.chartData, ['position'], ['desc'])
    }
  },

  watch: {
    room() {
      this.buildChart()
    }
  },

  mounted() {
    this.buildChart()
  },

  beforeDestroy() {
    this.chartDispose()
  },

  methods: {
    isEmpty,

    loadData() {
      return api.get(this.apiUrl)
    },

    buildChart() {
      if (!isEmpty(this.room)) {
        this.loadData()
          .then(({ data: { data, success } }) => {
            if (success) {
              this.chartData = data

              if (!isEmpty(this.chartData)) {
                this.initChart()
                this.initCategoryAxis()
                this.initValueAxis()
                this.initSeries()
              }
            }
          })
      }
    },

    initChart(){
      am4core.useTheme(am4themes_animated)
      this.chart = am4core.create(this.$refs.factor_price, am4charts.XYChart)
      this.chart.data = this.orderedChartData
      this.chart.svgContainer.htmlElement.style.height = "500px"
    },

    initCategoryAxis(){
      var categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "translated_factor_name"
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.grid.template.strokeWidth = 0
      categoryAxis.renderer.grid.template.lineAlpha = 0
      categoryAxis.fontSize = 13
    },

    initValueAxis() {
      var valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.strokeWidth = 1
      valueAxis.renderer.minGridDistance = 50
      valueAxis .renderer.ticks.template.location
      valueAxis.title.fontWeight = "bold"
      valueAxis.renderer.labels.template.fill = am4core.color("#7C91A7")
      valueAxis.title.rotation = 0
      valueAxis.fontSize = 13
      valueAxis.title.fill = am4core.color("#3D4A57")
      valueAxis.title.dy = -45
      valueAxis.title.dx = 33
    },

    initSeries() {
      var series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = "factor_value";
      series.dataFields.categoryY = "translated_factor_name";
      series.columns.template.maxWidth = 8
      series.columns.template.border = 0
      series.columns.template.adapter.add("fill", function(fill, target) {
        if (target.dataItem && (target.dataItem.valueX < 0)) {
          return am4core.color("#008BD0");
        } else {
          return am4core.color("#FE7125");
        }
      });
      series.columns.template.height = 19
      series.columns.template.strokeWidth = 0
    },

    resetModal() {
      this.chartDispose()
      this.$emit('reset')
    },

    chartDispose () {
      if (this.chart) {
        this.chart.dispose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .factor-chart {
    height: 400px;
    position: relative;
  }

  .no-data {
    bottom: 52%;
    left: 44%;
    position: absolute;
  }
</style>
